<template>
    <ui-modal-full-size :title="currentPreviewObject.name" :close="this.closeMe"
                        :large="needsIframe(currentPreviewObject.mimeType)">
        <input ref="focusCatcher" class="opacity-0 absolute"
               style="width: 1px; height:1px; margin:0px; padding:0px; overflow: hidden"
               @keydown.space="closeMe"
               @keydown.esc="closeMe"
               @keydown.up="previous"
               @keydown.down="next"
               @keydown.left="previous"
               @keydown.right="next"
        >
        <template #actions="{}">
            <ui-dropdown placement="bottom-end" menu-class="p-3 w-56" ref="menu">
                <template #default="{ toggle }">
                    <ui-button-new @click="toggle" primary>
                        Actions
                        <i class="flex-shrink-0 ml-2 fa fa-chevron-down"></i>
                    </ui-button-new>
                </template>
                <template #menu="{ close }">
                    <fs-selected-context-menu :selected="[currentPreviewObject]"
                                              :last-selected="{node:currentPreviewObject}"
                                              :non-system="[currentPreviewObject]"
                                              :can-show-info="false"
                                              :filesystem="filesystem"
                                              :close-menus="() => {}"
                                              :download-node="download"
                                              :rotations="rotations"
                                              :tags="false"
                    >
                    </fs-selected-context-menu>
                </template>
            </ui-dropdown>
        </template>
        <template v-if="needsIframe(currentPreviewObject.mimeType)">
            <div class="flex flex-grow overflow-hidden justify-center mx-2 md:mx-8 mb-5">
                <iframe frameborder="0" id="" class="w-full h-full mx-1 md:mx-5 " :src="currentPreviewObject.url"
                        @load="this.grabFocus"></iframe>
            </div>
        </template>
        <template v-else>
            <div v-if="currentPreviewObject.previewable" class="flex flex-initial overflow-hidden justify-center p-6">
                <img alt="" class="object-scale-down rounded-sm"
                     style="display: block;white-space: nowrap;max-width: 1200px; width: 100%;"
                     :src="getUrl()"/>
            </div>
            <div v-else class="p-2 sm:p-20">
                <div v-if="currentPreviewObject.type !== 'directory'">
                    <div class="flex flex-col sm:flex-row gap-8 items-center">
                        <i :class="`p-4 text-center text-gray-400 fa fas ${currentPreviewObject.icon}`"
                           style="font-size:8rem;"></i>
                        <div class="p-0 sm:pr-40">
                            <h3 class="text-4xl font-bold mb-4">{{ currentPreviewObject.name }}</h3>
                            <p class="text-gray-500 text-lg">Created {{ currentPreviewObject.createdAt }}</p>
                            <p class="text-gray-500 text-lg">by {{ currentPreviewObject.createdBy }}</p>
                            <p class="text-gray-400 mt-4" v-html="`Filesize: ${currentPreviewObject.size}`"></p>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="flex flex-col sm:flex-row gap-8 items-center">
                        <i :class="`p-4 text-center text-gray-400 fa fas fa-folder`" style="font-size:8rem;"></i>
                        <div class="p-0 sm:pr-40">
                            <h3 class="text-4xl font-bold mb-4">{{ currentPreviewObject.name }}</h3>
                            <p class="text-gray-500 text-lg">Created {{ currentPreviewObject.createdAt }}</p>
                            <p class="text-gray-500 text-lg">by {{ currentPreviewObject.createdBy }}</p>
                            <p class="text-gray-400 mt-4">Contains {{ currentPreviewObject.size }} objects</p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ui-modal-full-size>
</template>

<script>
import FsSelectedContextMenu from "./FsSelectedContextMenu.vue";

export default {
    components: {FsSelectedContextMenu},
    props: {
        previewObject: Object,
        filesystem: Object,
        current: Array,
        rotations: Object,
        close: Function,
        closed: Function,
        selected: Function,
        tags: true,
    },
    data() {
        return {
            isClosed: false,
            currentPreviewObject: this.previewObject
        }
    },
    watch: {
        'rotations.key': {
            handler(a, b) {
                this.$forceUpdate()
            },
        },
    },
    methods: {
        needsIframe(mimetype) {
            if (mimetype.startsWith('video/')) {
                return true;
            }
            return [
                'application/pdf',
                'image/mov',
                'audio/aiff',
                'audio/x-midi',
                'audio/x-wav',
            ].includes(mimetype)
        },
        closeMe(e) {
            if (!this.isClosed) {
                this.isClosed = true;
                this.close()
                if (this.closed) {
                    this.closed(e)
                }
            }
        },
        previous(e) {
            let index = this.current.indexOf(this.currentPreviewObject);
            let previous = this.current.toSpliced(index, this.current.length).reverse().find((e) => e.type === 'file');
            if (!previous) {
                previous = this.current.toReversed().find((e) => e.type === 'file');
            }
            if (previous) {
                this.currentPreviewObject = previous
                if (this.selected) {
                    this.selected(previous)
                }
            }
        },
        next(e) {
            let index = this.current.indexOf(this.currentPreviewObject);
            let next = this.current.toSpliced(0, index + 1).find((e) => e.type === 'file');
            if (!next) {
                next = this.current.find((e) => e.type === 'file');
            }
            if (next) {
                this.currentPreviewObject = next
                if (this.selected) {
                    this.selected(next)
                }
            }
        },
        grabFocus() {
            this.$nextTick(() => {
                this.$refs.focusCatcher.focus()
            })
        },
        download() {
            let a = document.createElement("a")
            document.body.appendChild(a)
            a.style = "display: none"
            a.href =  this.getUrl() + '?forceDownload=1';
            a.download = "download"
            a.click();
            document.body.removeChild(a);
        },
        getUrl() {
            if (!this.currentPreviewObject.supportsRotations) {
                return this.currentPreviewObject.url
            }
            let rot = this.rotations[this.currentPreviewObject.id];
            if (!rot) {
                return this.currentPreviewObject.url
            }
            return this.currentPreviewObject.rotations[rot] ? this.currentPreviewObject.rotations[rot].url : this.currentPreviewObject.url
        }
    },
    mounted() {
        const listener = (e) => {
            if (!this.$refs.menu.scope.opened && e.target.closest('.actions-container') === null) {
                this.grabFocus()
            }
        }
        window.addEventListener('mousemove', listener)
        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('mousemove', listener)
        })
        this.grabFocus()
    }
}
</script>
